import check_example from "./../../assets/images/check_example.png";

export const changeofAddressArr = [
  {
    field: "CHANGE OF ADDRESS FORM",
    arr: [
      {
        section: "Client Information",
        arr: [
          {
            title: "Date",
            field: "changeOfAddressForm_Date",
            type: "date",
            className: "col-12",
          },
          {
            title: "Loan ID Number",
            field: "changeOfAddressForm_LoanID",
            type: "text",
            className: "col-12",
          },
          {
            title: "Name",
            field: "changeOfAddressForm_Name",
            type: "text",
            className: "col-12",
          },
          {
            title: "Old Mailing Address",
            field: "changeOfAddressForm_OldAddress",
            type: "text",
            className: "col-12",
          },
          {
            title: "City, State, Zip (Old)",
            field: "changeOfAddressForm_OldCityStateZip",
            type: "text",
            className: "col-12",
          },
          {
            title: "New Mailing Address",
            field: "changeOfAddressForm_NewAddress",
            type: "text",
            className: "col-12",
          },
          {
            title: "City, State, Zip (New)",
            field: "changeOfAddressForm_NewCityStateZip",
            type: "text",
            className: "col-12",
          },
        ],
      },
      {
        section: "Client Information",
        arr: [
          {
            title: "Email Address",
            field: "changeOfAddressForm_Email",
            type: "email",
            className: "col-12",
          },
          {
            title: "Home Phone Number",
            field: "changeOfAddressForm_HomePhone",
            type: "phoneNumber",
            className: "col-12",
          },
          {
            title: "Cell Phone Number",
            field: "changeOfAddressForm_CellPhone",
            type: "phoneNumber",
            className: "col-12",
          },
          {
            type: "content",
            className: "col-12",
            content: (
              <p className="fs-5">
                I declare that the information provided is correct and I give
                Superior Loan Servicing the right to make the address change for
                their records.
              </p>
            ),
          },
          {
            title: "Signature",
            field: "changeOfAddressForm_signature",
            type: "text",
            className: "col-12",
          },
          {
            type: "content",
            className: "col-12",
            content: (
              <p className="fw-bold mt-5">
                Please complete this form and return it by mail or email to
                <a href="mailto:lss@slsbox.com"> lss@slsbox.com</a> or fax to
                818-876-0337.
              </p>
            ),
          },
        ],
      },
    ],
  },
];

export const oneTimeACHArr = [
  {
    field: "ONE-TIME ACH DIRECT DEBIT FORM",
    arr: [
      {
        section: "",
        arr: [
          {
            type: "content",
            className: "col-12",
            content: (
              <>
                <p className="">
                  Money is transferred from one bank account to another by
                  Electronic Funds Transfer (EFT) utilizing the Automated
                  Clearing House (ACH) Network governed by the Federal Reserve
                  System and the National Automated Clearing House Association
                  (NACHA).
                </p>
                <p className="fw-bold mt-3">
                  * A $15.00 —ONE-TIME PROCESSING FEE WILL BE ADDED TO THE
                  PAYMENT AMOUNT *
                </p>
              </>
            ),
          },
        ],
      },
      {
        section: "Borrower Information",
        arr: [
          {
            title: "SLS Account No.",
            field: "borrowerInfo_SLSAccountNo",
            type: "text",
            className: "col-12",
          },
          {
            title: "Authorized Payment Amount",
            field: "borrowerInfo_AuthorizedPaymentAmount",
            type: "number",
            className: "col-12",
          },
          {
            title: "Property Address",
            field: "borrowerInfo_PropertyAddress",
            type: "textarea",
            className: "col-12",
          },
          {
            title: "City",
            field: "borrowerInfo_City",
            type: "text",
            className: "col-4",
          },
          {
            title: "State",
            field: "borrowerInfo_State",
            type: "text",
            className: "col-4",
          },
          {
            title: "Zip Code",
            field: "borrowerInfo_ZipCode",
            type: "text",
            className: "col-4",
          },
          {
            title: "Email",
            field: "borrowerInfo_Email",
            type: "email",
            className: "col-6",
          },
          {
            title: "Phone Number",
            field: "borrowerInfo_PhoneNumber",
            type: "phoneNumber",
            className: "col-6",
          },
        ],
      },
      {
        section:
          "Banking Account Information (Bank accounts must be titled exactly as your account with SLS.)",
        arr: [
          {
            title: "Account Name(s)",
            field: "bankInfo_AccountNames",
            type: "text",
            className: "col-12",
          },
          {
            title: "Bank Name",
            field: "bankInfo_BankName",
            type: "text",
            className: "col-12",
          },
          {
            type: "content",
            className: "col-4",
            content: <label className="">Account Type:</label>,
          },
          {
            title: "Checking",
            field: "bankInfo_checking",
            type: "checkbox",
            className: "col-4",
          },
          {
            title: "Savings",
            field: "bankInfo_savings",
            type: "checkbox",
            className: "col-4",
          },
          {
            title: "Bank Address",
            field: "bankInfo_BankAddress",
            type: "text",
            className: "col-12",
          },
          {
            title: "City",
            field: "bankInfo_BankCity",
            type: "text",
            className: "col-6",
          },
          {
            title: "State",
            field: "bankInfo_BankState",
            type: "text",
            className: "col-3",
          },
          {
            title: "Zip Code",
            field: "bankInfo_BankZipCode",
            type: "text",
            className: "col-3",
          },
          {
            title: "Routing Number",
            field: "bankInfo_RoutingNumber",
            type: "text",
            className: "col-12",
          },
          {
            title: "Account Number",
            field: "bankInfo_AccountNumber",
            type: "text",
            className: "col-12",
          },
          {
            type: "content",
            className: "col-12",
            content: (
              <>
                <p className="">
                  These numbers are located on the bottom of your check as
                  follows:
                </p>
                <img
                  width="700"
                  src={check_example}
                  alt="The lower-left  of a bank check, indicating the routing number is typically found on the bottom left and the account number on the bottom center. "
                />
                <p>
                  I(We) authorize SLS to initiate ACH transactions to my/our
                  account indicated in accordance with the provisions of U.S.
                  law and understand if this payment is returned due to
                  Insufficent Funds (NSF) or an invalid Checking Account #, I
                  (we) are subject to a $45 NSF Fee.:
                </p>
              </>
            ),
          },
          {
            title: "Borrower Signature",
            field: "bankInfo_BorrowerSignature",
            type: "text",
            className: "col-6",
          },
          {
            title: "Borrower 2 Signature",
            field: "bankInfo_Borrower2Signature",
            type: "text",
            className: "col-6",
          },
          {
            title: "Print Name",
            field: "bankInfo_PrintName",
            type: "text",
            className: "col-6",
          },
          {
            title: "Print Name",
            field: "bankInfo_PrintName2",
            type: "text",
            className: "col-6",
          },
          {
            type: "content",
            className: "col-12",
            content: (
              <>
                <p className="fw-bold">
                  Please complete this form and <u>SUBMIT A VOIDED CHECK</u> and
                  email to <a href="mailto:LSS@slsbox.com">LSS@slsbox.com</a>.
                </p>
                <p>An email confirmation will be sent via email.</p>
              </>
            ),
          },
        ],
      },
    ],
  },
];

export const achRecurringFormArr = [
  {
    field: "ACH DIRECT DEBIT FORM - RECURRING",
    arr: [
      {
        section: "",
        arr: [
          {
            type: "content",
            className: "col-12",
            content: (
              <p>
                Money is transferred from one bank account to another by
                Electronic Funds Transfer (EFT) utilizing the Automated Clearing
                House (ACH) Network governed by the Federal Reserve System and
                the National Automated Clearing House Association (NACHA).{" "}
              </p>
            ),
          },
        ],
      },
      {
        section: (
          <>
            Borrower Information:{" "}
            <p>
              I(we) hereby authorize Superior Loan Servicing to electronically
              debit my(our) account.
            </p>
          </>
        ),
        arr: [
          {
            title: "Borrower Name",
            field: "achForm_BorrowerName",
            type: "text",
            className: "col-12",
          },
          {
            title: "Loan ID Number",
            field: "achForm_LoanID",
            type: "text",
            className: "col-12",
          },
          {
            title: "Phone Number",
            field: "achForm_PhoneNumber",
            type: "phoneNumber",
            className: "col-12",
          },
          {
            title: "Email",
            field: "achForm_Email",
            type: "email",
            className: "col-12",
          },
          {
            title:
              "Please select a debit date within your grace period and refer to your loan terms/documents to not incur a late fee.",
            field: "achForm_debitdate",
            type: "date",
            className: "col-12",
          },
        ],
      },
      {
        section: "Banking Account Information",
        arr: [
          {
            title: "Account Name",
            field: "achForm_AccountName",
            type: "text",
            className: "col-12",
          },
          {
            title: "Bank Name",
            field: "achForm_BankName",
            type: "text",
            className: "col-12",
          },
          {
            type: "content",
            className: "col-4",
            content: <label>Account Type</label>,
          },
          {
            title: "Checking",
            field: "achForm_Checking",
            type: "checkbox",
            className: "col-4",
          },
          {
            title: "Savings",
            field: "achForm_Savings",
            type: "checkbox",
            className: "col-4",
          },
          {
            title: "Routing Number",
            field: "achForm_RoutingNumber",
            type: "text",
            className: "col-6",
          },
          {
            title: "Account Number",
            field: "achForm_AccountNumber",
            type: "text",
            className: "col-6",
          },
          {
            type: "content",
            className: "col-12",
            content: (
              <>
                <p className="">
                  These numbers are located on the bottom of your check as
                  follows:
                </p>
                <img
                  width="700"
                  src={check_example}
                  alt="The lower-left  of a bank check, indicating the routing number is typically found on the bottom left and the account number on the bottom center. "
                />
                <p>
                  I(We) authorize SLS to initiate monthly ACH transactions for
                  the full payment amount due as billed from my/our account
                  indicated in accordance with the provisions of US law and
                  understand if this payment is returned due to Insufficent
                  Funds (NSF) or an invalid Checking Account #, I (we) are
                  subject to a $45 NSF Fee. I understand that this authorization
                  will remain in full force and effect until I(we) notify
                  Superior Loan Servicing that I(we) wish to revoke this
                  authorization.
                </p>
              </>
            ),
          },
          {
            title: "Borrower Signature",
            field: "achForm_BorrowerSignature",
            type: "text",
            className: "col-6",
          },
          {
            title: "Borrower 2 Signature",
            field: "achForm_Borrower2Signature",
            type: "text",
            className: "col-6",
          },
          {
            title: "Print Name",
            field: "achForm_PrintName",
            type: "text",
            className: "col-6",
          },
          {
            title: "Print Name",
            field: "achForm_PrintName2",
            type: "text",
            className: "col-6",
          },
          {
            type: "content",
            className: "col-12",
            content: (
              <>
                <p className="fw-bold">
                  Please complete this form and <u>SUBMIT A VOIDED CHECK</u> and
                  email to <a href="mailto:lss@slsbox.com">lss@slsbox.com</a>.
                </p>
                <p>An email confirmation will be sent via email.</p>
              </>
            ),
          },
        ],
      },
    ],
  },
];

export const demandRequestArr = [
  {
    field: "Demand Request Form",
    arr: [
      {
        section: "",
        arr: [
          {
            title: "Loan No.",
            field: "demandRequestForm_LoanNo",
            type: "text",
            className: "col-12",
          },
          {
            title: "Borrower",
            field: "demandRequestForm_Borrower",
            type: "text",
            className: "col-12",
          },
          {
            title: "Property",
            field: "demandRequestForm_Property",
            type: "text",
            className: "col-12",
          },
          {
            title: "Company Requesting",
            field: "demandRequestForm_CompanyRequesting",
            type: "text",
            className: "col-12",
          },
          {
            title: "Title Company",
            field: "demandRequestForm_TitleCompany",
            type: "text",
            className: "col-12",
          },
          {
            title: "File No.",
            field: "demandRequestForm_FileNo",
            type: "text",
            className: "col-12",
          },
          {
            title: "Person Requesting",
            field: "demandRequestForm_PersonRequesting",
            type: "text",
            className: "col-12",
          },
          {
            title: "Escrow Company",
            field: "demandRequestForm_EscrowCompany",
            type: "text",
            className: "col-12",
          },
          {
            title: "Escrow Officer",
            field: "demandRequestForm_EscrowOfficer",
            type: "text",
            className: "col-12",
          },
          {
            title: "Escrow No.",
            field: "demandRequestForm_EscrowNo",
            type: "text",
            className: "col-12",
          },
          {
            title: "Estimated Closing Date",
            field: "demandRequestForm_EstimatedClosingDate",
            type: "date",
            className: "col-12",
          },
          {
            title: "Email Demand to",
            field: "demandRequestForm_EmailDemandTo",
            type: "email",
            className: "col-12",
          },
          {
            type: "content",
            className: "col-6",
            content: <label className="fw-bold">$30 Demand Fee</label>,
          },
          {
            title: "Additional $75 for RUSH Demand Request",
            field: "demandRequestForm_RushDemandFee",
            type: "checkbox",
            className: "col-6",
          },
        ],
      },
      {
        section: "",
        arr: [
          {
            type: "content",
            className: "col-12 px-5",
            content: (
              <>
                <p className="fw-bold">
                  All requests for demand must include a form of authorization
                  from the requesting Escrow and/or Title Company signed by the
                  borrower.
                </p>
                <p className="fw-bold">
                  SLS Demand Request form must be signed by the requesting
                  Escrow and/or Title Company. Please forward demand request to{" "}
                  <a href="mailto:demands@slsbox.com">demands@slsbox.com</a>.
                </p>
                <p className="fw-bold">
                  Superior Loan Servicing as agent for the beneficiary will
                  reconvey/release/discharge the lien upon receipt of payment in
                  full.{" "}
                  <span className="text-decoration-underline">
                    All funds must be made payable to Superior Loan Servicing.
                  </span>
                </p>
                <p>
                  By signing below I understand that by requesting a demand from
                  Superior Loan Servicing you hereby acknowledge that Superior
                  Loan Servicing, a loan servicer licensed in the State of
                  California through the California Bureau of Real Estate is the
                  authorized agent for the Beneficiary as per our servicing
                  agreement. All funds for payoff are to be made payable to
                  Superior Loan Servicing. Any use of the demand issued by
                  Superior Loan Servicing to pay to any other payee other than
                  Superior Loan Servicing is a violation of this agreement and
                  will be subject to legal recourse.
                </p>
              </>
            ),
          },
        ],
      },
      {
        section: "",
        arr: [
          {
            title: "Signature",
            field: "demandRequestForm_Signature",
            type: "text",
            className: "col-6",
          },
          {
            title: "Print Name/Title or Escrow Officer ",
            field: "demandRequestForm_PrintNameTitle",
            type: "text",
            className: "col-6",
          },
          {
            type: "content",
            className: "col-12",
            content: (
              <p>
                <b>****NOTE: This is NOT a Borrowers Authorization.</b>{" "}
                Borrowers Authorization must be provided from requesting
                company.{" "}
              </p>
            ),
          },
        ],
      },
    ],
  },
];

export const IRSW9formArr = [
  {
    field: "IRS-W9 Form",
    arr: [
      {
        section: "",
        arr: [
          {
            title: "Name",
            field: "form_Name",
            type: "text",
            className: "col-12",
          },
          {
            title: "Business Name/Disregarded Entity Name",
            field: "form_BusinessName",
            type: "text",
            className: "col-12",
          },
          {
            type: "content",
            className: "col-12",
            content: (
              <p>
                Check appropriate box for federal tax classification of the
                person whose name is entered on line 1. Check only one of the
                following seven boxes.
              </p>
            ),
          },
          {
            title:
              "Federal Tax Classification - Individual/Sole Proprietor or Single-member LLC",
            field: "form_TaxClassification_Individual",
            type: "checkbox",
            className: "col-3",
          },
          {
            title: "Federal Tax Classification - C Corporation",
            field: "form_TaxClassification_CCorp",
            type: "checkbox",
            className: "col-3",
          },
          {
            title: "Federal Tax Classification - S Corporation",
            field: "form_TaxClassification_SCorp",
            type: "checkbox",
            className: "col-3",
          },
          {
            title: "Federal Tax Classification - Partnership",
            field: "form_TaxClassification_Partnership",
            type: "checkbox",
            className: "col-3",
          },
          {
            title: "Federal Tax Classification - Trust/Estate",
            field: "form_TaxClassification_TrustEstate",
            type: "checkbox",
            className: "col-4",
          },
          {
            title: "Federal Tax Classification - Limited Liability Company",
            field: "form_TaxClassification_LLC",
            type: "checkbox",
            className: "col-4",
          },
          {
            title:
              " Enter the tax classification (C=C corporation, S=S corporation, P=Partnership)",
            field: "form_TaxClassification_LLC_input",
            type: "text",
            className: "col-4",
          },
          {
            type: "content",
            className: "col-12",
            content: (
              <p>
                <b>Note:</b> Check the appropriate box in the line above for the
                tax classification of the single-member owner. Do not check LLC
                if the LLC is classified as a single-member LLC that is
                disregarded from the owner unless the owner of the LLC is
                another LLC that is not disregarded from the owner for U.S.
                federal tax purposes. Otherwise, a single-member LLC that is
                disregarded from the owner should check the appropriate box for
                the tax classification of its owner.
              </p>
            ),
          },
          {
            title: "Federal Tax Classification - Other",
            field: "form_TaxClassification_Other",
            type: "checkbox",
            className: "col-12",
          },
          {
            type: "content",
            className: "col-12",
            content: (
              <label>
                Exemptions (codes apply only to certain entities, not
                individuals; see Specific Instructions):
              </label>
            ),
          },
          {
            title: "Exempt Payee Code",
            field: "form_ExemptPayeeCode",
            type: "text",
            className: "col-12",
          },
          {
            title: "Exemption from FATCA Reporting Code",
            field: "form_FATCAExemptionCode",
            type: "text",
            className: "col-12",
          },
        ],
      },
      {
        section: "",
        className: "col-6 border",
        arr: [
          {
            title:
              " Address (number, street, and apt. or suite no.) See instructions.",
            field: "form_Address",
            type: "textarea",
            className: "col-12",
          },
          {
            title: "City, State, and ZIP Code",
            field: "form_CityStateZip",
            type: "textarea",
            className: "col-12",
          },
          {
            title: "List account number(s) here (optional)",
            field: "form_AccountNumbers",
            type: "textarea",
            className: "col-12",
          },
        ],
      },
      {
        section: "",
        className: "col-6 border",
        arr: [
          {
            title: "Requester’s name and address (optional)",
            field: "form_requestor_info",
            type: "textarea",
            className: "col-12",
          },
        ],
      },
      {
        section: "Part I Taxpayer Identification Number (TIN)",
        className: "col-8",
        arr: [
          {
            type: "content",
            content: (
              <>
                <p>
                  Enter your TIN in the appropriate box. The TIN provided must
                  match the name given on line 1 to avoid backup withholding.
                  For individuals, this is generally your social security number
                  (SSN). However, for a resident alien, sole proprietor, or
                  disregarded entity, see the instructions for Part I, later.
                  For other entities, it is your employer identification number
                  (EIN). If you do not have a number, see How to get a TIN,
                  later.
                </p>
                <p>
                  <b>Note:</b> If the account is in more than one name, see the
                  instructions for line 1. Also see What Name and Number To Give
                  the Requester for guidelines on whose number to enter.
                </p>
              </>
            ),
          },
        ],
      },
      {
        section: "",
        className: "col-4",
        arr: [
          {
            title: "Social security number",
            field: "form_SSN",
            type: "otp",
            length: 9,
            pattern: "123-45-6789",
            className: "col-12",
          },
          {
            type: "content",
            className: "col-12",
            content: <p>or</p>,
          },
          {
            title: "Employer identification number",
            field: "form_EIN",
            type: "otp",
            length: 9,
            pattern: "12-3456789",
            className: "col-12",
          },
        ],
      },
      {
        section: "Part II Certification",
        className: "col-12",
        arr: [
          {
            type: "content",
            className: "col-12",
            content: (
              <div className="">
                <p>Under penalties of perjury, I certify that:</p>
                <ol>
                  <li>
                    The number shown on this form is my correct taxpayer
                    identification number (or I am waiting for a number to be
                    issued to me); and
                  </li>
                  <li>
                    I am not subject to backup withholding because:
                    <ol type="a">
                      <li>I am exempt from backup withholding, or</li>
                      <li>
                        I have not been notified by the Internal Revenue Service
                        (IRS) that I am subject to backup withholding as a
                        result of a failure to report all interest or dividends,
                        or
                      </li>
                      <li>
                        The IRS has notified me that I am no longer subject to
                        backup withholding; and
                      </li>
                    </ol>
                  </li>
                  <li>
                    I am a U.S. citizen or other U.S. person (defined below);
                    and
                  </li>
                  <li>
                    The FATCA code(s) entered on this form (if any) indicating
                    that I am exempt from FATCA reporting is correct.
                  </li>
                </ol>
                <p className="">
                  <b>Certification instructions.</b> You must cross out item 2
                  above if you have been notified by the IRS that you are
                  currently subject to backup withholding because you have
                  failed to report all interest and dividends on your tax
                  return. For real estate transactions, item 2 does not apply.
                  For mortgage interest paid, acquisition or abandonment of
                  secured property, cancellation of debt, contributions to an
                  individual retirement arrangement (IRA), and generally,
                  payments other than interest and dividends, you are not
                  required to sign the certification, but you must provide your
                  correct TIN. See the instructions for Part II, later.
                </p>
              </div>
            ),
          },
          {
            type: "content",
            className: "col-4",
            content: <b>Sign Here</b>,
          },
          {
            title: "Signature of U.S. person",
            field: "form_signatureofUSPerson",
            type: "sign",
            className: "col-4",
          },
          {
            title: "Date",
            field: "form_date",
            type: "date",
            className: "col-4",
          },
        ],
      },
      {
        section: "",
        className: "col-12",
        arr: [
          {
            type: "content",
            className: "col-12",
            content: (
              <div className="mt-3">
                <div className="row">
                  <div className="col-6">
                    <h4>General Instructions</h4>
                    <p>
                      Section references are to the Internal Revenue Code unless
                      otherwise noted.
                    </p>
                    <h5>Future Developments</h5>
                    <p>
                      For the latest information about developments related to
                      Form W-9 and its instructions, such as legislation enacted
                      after they were published, go to{" "}
                      <a
                        href="http://www.irs.gov/FormW9"
                        className="link-primary"
                      >
                        www.irs.gov/FormW9
                      </a>
                      .
                    </p>

                    <h5>Purpose of Form</h5>
                    <p>
                      An individual or entity (Form W-9 requester) who is
                      required to file an information return with the IRS must
                      obtain your correct taxpayer identification number (TIN)
                      which may be your social security number (SSN), individual
                      taxpayer identification number (ITIN), adoption taxpayer
                      identification number (ATIN), or employer identification
                      number (EIN), to report on an information return the
                      amount paid to you, or other amount reportable on an
                      information return. Examples of information returns
                      include, but are not limited to, the following.
                    </p>
                  </div>
                  <div className="col-6">
                    <ul>
                      <li>Form 1099-INT (interest earned or paid)</li>
                      <li>
                        Form 1099-DIV (dividends, including those from stocks or
                        mutual funds)
                      </li>
                      <li>
                        Form 1099-MISC (various types of income, prizes, awards,
                        or gross proceeds)
                      </li>
                      <li>
                        Form 1099-B (stock or mutual fund sales and certain
                        other transactions by brokers)
                      </li>
                      <li>
                        Form 1099-S (proceeds from real estate transactions)
                      </li>
                      <li>
                        Form 1099-K (merchant card and third party network
                        transactions)
                      </li>
                      <li>
                        Form 1098 (home mortgage interest), 1098-E (student loan
                        interest), 1098-T (tuition)
                      </li>
                      <li>Form 1099-C (canceled debt)</li>
                      <li>
                        Form 1099-A (acquisition or abandonment of secured
                        property)
                      </li>
                    </ul>
                    <p>
                      Use Form W-9 only if you are a U.S. person (including a
                      resident alien), to provide your correct TIN. If you do
                      not return Form W-9 to the requester with a TIN, you might
                      be subject to backup withholding. See What is backup
                      withholding, later.
                    </p>
                  </div>
                </div>
              </div>
            ),
          },
          {
            type: "content",
            className: "col-6",
            content: (
              <div className=" mt-4">
                <p>By signing the filled-out form, you:</p>
                <ol className="list-group list-group-numbered">
                  <li className="list-group-item">
                    Certify that the TIN you are giving is correct (or you are
                    waiting for a number to be issued),
                  </li>
                  <li className="list-group-item">
                    Certify that you are not subject to backup withholding, or
                  </li>
                  <li className="list-group-item">
                    Claim exemption from backup withholding if you are a U.S.
                    exempt payee. If applicable, you are also certifying that as
                    a U.S. person, your allocable share of any partnership
                    income from a U.S. trade or business is not subject to the
                    withholding tax on foreign partners' share of effectively
                    connected income,
                  </li>
                  <li className="list-group-item">
                    Certify that FATCA code(s) entered on this form (if any)
                    indicating that you are exempt from the FATCA reporting, is
                    correct. See What is FATCA reporting, later, for further
                    information.
                  </li>
                </ol>
                <p>
                  <b>Note:</b> If you are a U.S. person and a requester gives
                  you a form other than Form W-9 to request your TIN, you must
                  use the requester’s form if it is substantially similar to
                  this Form W-9.
                </p>
                <h4>Definition of a U.S. person</h4>
                <p>
                  For federal tax purposes, you are considered a U.S. person if
                  you are:
                </p>
                <ul className="list-group list-group-flush">
                  <li className="list-group-item">
                    An individual who is a U.S. citizen or U.S. resident alien;
                  </li>
                  <li className="list-group-item">
                    A partnership, corporation, company, or association created
                    or organized in the United States or under the laws of the
                    United States;
                  </li>
                  <li className="list-group-item">
                    An estate (other than a foreign estate);
                  </li>
                  <li className="list-group-item">
                    A domestic trust (as defined in Regulations section
                    301.7701-7).
                  </li>
                </ul>
                <h4>Special rules for partnerships</h4>
                <p>
                  Partnerships that conduct a trade or business in the United
                  States are generally required to pay a withholding tax under
                  section 1446 on any foreign partners’ share of effectively
                  connected taxable income from such business. Further, in
                  certain cases where a Form W-9 has not been received, the
                  rules under section 1446 require a partnership to presume that
                  a partner is a foreign person, and pay the section 1446
                  withholding tax. Therefore, if you are a U.S. person that is a
                  partner in a partnership conducting a trade or business in the
                  United States, provide Form W-9 to the partnership to
                  establish your U.S. status and avoid section 1446 withholding
                  on your share of partnership income.
                </p>
                <p>
                  In the cases below, the following person must give Form W-9 to
                  the partnership for purposes of establishing its U.S. status
                  and avoiding withholding on its allocable share of net income
                  from the partnership conducting a trade or business in the
                  United States.
                </p>
                <ul className="list-group list-group-flush">
                  <li className="list-group-item">
                    In the case of a disregarded entity with a U.S. owner, the
                    U.S. owner of the disregarded entity and not the entity;
                  </li>
                  <li className="list-group-item">
                    In the case of a grantor trust with a U.S. grantor or other
                    U.S. owner, generally, the U.S. grantor or other U.S. owner
                    of the grantor trust and not the trust;
                  </li>
                  <li className="list-group-item">
                    In the case of a U.S. trust (other than a grantor trust),
                    the U.S. trust and not the beneficiaries of the trust.
                  </li>
                </ul>
                <p>
                  Foreign person. If you are a foreign person or the U.S. branch
                  of a foreign bank that has elected to be treated as a U.S.
                  person, do not use Form W-9. Instead, use the appropriate Form
                  W-8 or Form 8233 (see Pub. 515, Withholding of Tax on
                  Nonresident Aliens and Foreign Entities).
                </p>
                <p>
                  Nonresident alien who becomes a resident alien. Generally,
                  only a nonresident alien individual may use the terms of a tax
                  treaty to reduce or eliminate U.S. tax on certain types of
                  income. However, most tax treaties contain a provision known
                  as a “saving clause.” Exceptions specified in the saving
                  clause may permit an exemption from tax to continue for
                  certain types of income even after the payee has otherwise
                  become a U.S. resident alien for tax purposes.
                </p>
              </div>
            ),
          },
          {
            type: "content",
            className: "col-6",
            content: (
              <div className="container mt-3">
                <div className="row">
                  <div className="col">
                    <p>
                      <b>Example</b> Article 20 of the U.S.-China income tax
                      treaty allows an exemption from tax for scholarship income
                      received by a Chinese student temporarily present in the
                      United States. Under U.S. law, this student will become a
                      resident alien for tax purposes if his or her stay in the
                      United States exceeds 5 calendar years. However, paragraph
                      2 of the first Protocol to the U.S.-China treaty (dated
                      April 30, 1984) allows the provisions of Article 20 to
                      continue to apply even after the Chinese student becomes a
                      resident alien of the United States. A Chinese student who
                      qualifies for this exception (under paragraph 2 of the
                      first protocol) and is relying on this exception to claim
                      an exemption from tax on his or her scholarship or
                      fellowship income would attach to Form W-9 a statement
                      that includes the information described above to support
                      that exemption.
                    </p>
                    <p>
                      If you are a nonresident alien or a foreign entity, give
                      the requester the appropriate completed Form W-8 or Form
                      8233.
                    </p>

                    <h4>Backup Withholding</h4>
                    <p>
                      What is backup withholding? Persons making certain
                      payments to you must under certain conditions withhold and
                      pay to the IRS 24% of such payments. This is called
                      “backup withholding.” Payments that may be subject to
                      backup withholding include interest, tax-exempt interest,
                      dividends, broker and barter exchange transactions, rents,
                      royalties, nonemployee pay, payments made in settlement of
                      payment card and third party network transactions, and
                      certain payments from fishing boat operators. Real estate
                      transactions are not subject to backup withholding.
                    </p>
                    <p>
                      You will not be subject to backup withholding on payments
                      you receive if you give the requester your correct TIN,
                      make the proper certifications, and report all your
                      taxable interest and dividends on your tax return.
                    </p>
                    <ul>
                      <li>You do not furnish your TIN to the requester,</li>
                      <li>
                        You do not certify your TIN when required (see the
                        instructions for Part II for details),
                      </li>
                      <li>
                        The IRS tells the requester that you furnished an
                        incorrect TIN,
                      </li>
                      <li>
                        The IRS tells you that you are subject to backup
                        withholding because you did not report all your interest
                        and dividends on your tax return (for reportable
                        interest and dividends only), or
                      </li>
                      <li>
                        You do not certify to the requester that you are not
                        subject to backup withholding under 4 above (for
                        reportable interest and dividend accounts opened after
                        1983 only).
                      </li>
                    </ul>
                    <p>
                      Certain payees and payments are exempt from backup
                      withholding. See Exempt payee code, later, and the
                      separate Instructions for the Requester of Form W-9 for
                      more information.
                    </p>

                    <h4>What is FATCA Reporting?</h4>
                    <p>
                      The Foreign Account Tax Compliance Act (FATCA) requires a
                      participating foreign financial institution to report all
                      United States account holders that are specified United
                      States persons. Certain payees are exempt from FATCA
                      reporting. See Exemption from FATCA reporting code, later,
                      and the Instructions for the Requester of Form W-9 for
                      more information.
                    </p>

                    <h4>Updating Your Information</h4>
                    <p>
                      You must provide updated information to any person to whom
                      you claimed to be an exempt payee if you are no longer an
                      exempt payee and anticipate receiving reportable payments
                      in the future from this person. For example, you may need
                      to provide updated information if you are a C corporation
                      that elects to be an S corporation, or if you no longer
                      are tax exempt. In addition, you must furnish a new Form
                      W-9 if the name or TIN changes for the account; for
                      example, if the grantor of a grantor trust dies.
                    </p>

                    <h4>Penalties</h4>
                    <p>
                      Failure to furnish TIN. If you fail to furnish your
                      correct TIN to a requester, you are subject to a penalty
                      of $50 for each such failure unless your failure is due to
                      reasonable cause and not to willful neglect.
                    </p>
                    <p>
                      Civil penalty for false information with respect to
                      withholding. If you make a false statement with no
                      reasonable basis that results in no backup withholding,
                      you are subject to a $500 penalty.
                    </p>
                  </div>
                </div>
              </div>
            ),
          },
          {
            type: "content",
            className: "col-6",
            content: (
              <div className="container mt-3">
                <div className="row">
                  <div className="col">
                    <p>
                      <b>Criminal Penalty for Falsifying Information</b>{" "}
                      Willfully falsifying certifications or affirmations may
                      subject you to criminal penalties including fines and/or
                      imprisonment.
                    </p>

                    <p>
                      <b>Misuse of TINs</b> If the requester discloses or uses
                      TINs in violation of federal law, the requester may be
                      subject to civil and criminal penalties.
                    </p>

                    <h4>Specific Instructions</h4>
                    <p>
                      <strong>Line 1:</strong> You must enter one of the
                      following on this line; do not leave this line blank. The
                      name should match the name on your tax return.
                    </p>
                    <ul>
                      <li>
                        If this Form W-9 is for a joint account (other than an
                        account maintained by a foreign financial institution
                        (FFI)), list first, and then circle, the name of the
                        person or entity whose number you entered in Part I of
                        Form W-9.
                      </li>
                      <li>
                        If you are providing Form W-9 to an FFI to document a
                        joint account, each holder of the account that is a U.S.
                        person must provide a Form W-9.
                      </li>
                    </ul>
                    <p>
                      <strong>a. Individual.</strong> Generally, enter the name
                      shown on your tax return. If you have changed your last
                      name without informing the Social Security Administration
                      (SSA) of the name change, enter your first name, the last
                      name as shown on your social security card, and your new
                      last name.
                    </p>
                    <p>
                      <strong>Note:</strong> ITIN applicant: Enter your
                      individual name as it was entered on your Form W-7
                      application, line 1a. This should also be the same as the
                      name you entered on the Form 1040/1040A/1040EZ you filed
                      with your application.
                    </p>
                    <p>
                      <strong>b. Sole proprietor or single-member LLC.</strong>{" "}
                      Enter your individual name as shown on your
                      1040/1040A/1040EZ on line 1. You may enter your business,
                      trade, or “doing business as” (DBA) name on line 2.
                    </p>
                    <p>
                      <strong>
                        c. Partnership, LLC that is not a single-member LLC, C
                        corporation, or S corporation.
                      </strong>{" "}
                      Enter the entity's name as shown on the entity's tax
                      return on line 1 and any business, trade, or DBA name on
                      line 2.
                    </p>
                    <p>
                      <strong>d. Other entities.</strong> Enter your name as
                      shown on required U.S. federal tax documents on line 1.
                      This name should match the name shown on the charter or
                      other legal document creating the entity. You may enter
                      any business, trade, or DBA name on line 2.
                    </p>
                    <p>
                      <strong>e. Disregarded entity.</strong> For U.S. federal
                      tax purposes, an entity that is disregarded as an entity
                      separate from its owner is treated as a “disregarded
                      entity.” Enter the owner's name on line 1. The name of the
                      entity entered on line 1 should never be a disregarded
                      entity. The name on line 1 should be the name shown on the
                      income tax return on which the income should be reported.
                    </p>
                    <p>
                      If the direct owner of the entity is also a disregarded
                      entity, enter the first owner that is not disregarded for
                      federal tax purposes. Enter the disregarded entity's name
                      on line 2, “Business name/disregarded entity name.” If the
                      owner of the disregarded entity is a foreign person, the
                      owner must complete an appropriate Form W-8 instead of a
                      Form W-9. This is the case even if the foreign person has
                      a U.S. TIN.
                    </p>
                    <p>
                      <strong>Line 2:</strong> If you have a business name,
                      trade name, DBA name, or disregarded entity name, you may
                      enter it on line 2.
                    </p>
                    <p>
                      <strong>Line 3:</strong> Check the appropriate box on line
                      3 for the U.S. federal tax classification of the person
                      whose name is entered on line 1. Check only one box on
                      line 3.
                    </p>
                  </div>
                </div>
              </div>
            ),
          },
          {
            type: "content",
            className: "col-6",
            content: (
              <div className="container mt-3">
                <div className="row">
                  <div className="col">
                    <table className="table border border-2">
                      <thead>
                        <tr>
                          <th scope="col border border-1">
                            IF the entity/person on line 1 is an(n)...
                          </th>
                          <th scope="col">THEN check the box for...</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td className="border border-1">Corporation</td>
                          <td className="border border-1">Corporation</td>
                        </tr>
                        <tr>
                          <td className="border border-1">Individual</td>
                          <td className="border border-1">
                            Individual/sole proprietor or single-member LLC
                          </td>
                        </tr>
                        <tr>
                          <td className="border border-1">
                            Sole proprietorship, or Single-member limited
                            liability company (LLC) owned by an individual and
                            disregarded for U.S. federal tax purposes
                          </td>
                          <td className="border border-1">
                            Limited liability company and enter the appropriate
                            tax classification. (P= Partnership; C= C
                            corporation; or S= S corporation)
                          </td>
                        </tr>
                        <tr>
                          <td className="border border-1">
                            LLC treated as a partnership for U.S. federal tax
                            purposes, LLC that has filed Form 8832 or 2553 to be
                            taxed as a corporation, or LLC that is disregarded
                            as an entity separate from its owner but the owner
                            is another LLC that is not disregarded for U.S.
                            federal tax purposes.
                          </td>
                          <td className="border border-1">Partnership</td>
                        </tr>
                        <tr>
                          <td className="border border-1">Partnership</td>
                          <td className="border border-1">Partnership</td>
                        </tr>
                        <tr>
                          <td className="border border-1">Trust/estate</td>
                          <td className="border border-1">Trust/estate</td>
                        </tr>
                      </tbody>
                    </table>

                    <h4>Line 4, Exemptions</h4>
                    <p>
                      If you are exempt from backup withholding and/or FATCA
                      reporting, enter in the appropriate space on line 4 any
                      code(s) that may apply to you.
                    </p>
                    <ul className="list-unstyled">
                      <li>
                        Generally, individuals (including sole proprietors) are
                        not exempt from backup withholding.
                      </li>
                      <li>
                        Corporations are not exempt from backup withholding for
                        certain payments, including interest and dividends.
                      </li>
                    </ul>
                    <p>
                      The following codes identify payees that are exempt from
                      backup withholding. Enter the appropriate code in the
                      space in line 4.
                    </p>
                    <ul className="list-group">
                      <li className="list-group-item">
                        1 – An organization exempt from tax under section
                        501(a), any IRA, or a custodial account under section
                        403(b)(7) if the account satisfies the requirements of
                        section 401(f)(2)
                      </li>
                      <li className="list-group-item">
                        2 – The United States or any of its agencies or
                        instrumentalities
                      </li>
                      <li className="list-group-item">
                        3—A state, the District of Columbia, a U.S. commonwealth
                        or possession, or any of their political subdivisions or
                        instrumentalities
                      </li>
                      <li className="list-group-item">
                        4—A foreign government or any of its political
                        subdivisions, agencies, or instrumentalities
                      </li>
                      <li className="list-group-item">5—A corporation</li>
                      <li className="list-group-item">
                        6—A dealer in securities or commodities required to
                        register in the United States, the District of Columbia,
                        or a U.S. commonwealth or possession
                      </li>
                      <li className="list-group-item">
                        7—A futures commission merchant registered with the
                        Commodity Futures Trading Commission
                      </li>
                      <li className="list-group-item">
                        8—A real estate investment trust
                      </li>
                      <li className="list-group-item">
                        9—An entity registered at all times during the tax year
                        under the Investment Company Act of 1940
                      </li>
                      <li className="list-group-item">
                        10—A common trust fund operated by a bank under section
                        584(a)
                      </li>
                      <li className="list-group-item">
                        11—A financial institution
                      </li>
                      <li className="list-group-item">
                        12—A middleman known in the investment community as a
                        nominee or custodian
                      </li>
                      <li className="list-group-item">
                        13—A trust exempt from tax under section 664 or
                        described in section 4947
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            ),
          },
          {
            type: "content",
            className: "col-6",
            content: (
              <div className="container mt-3">
                <div className="row">
                  <div className="col">
                    <p>
                      The following chart shows types of payments that may be
                      exempt from backup withholding. The chart applies to the
                      exempt payees listed above, 1 through 13.
                    </p>

                    <table className="table">
                      <thead>
                        <tr>
                          <th className="border border-end">
                            IF the payment is for...
                          </th>
                          <th className="border border-end">
                            THEN the payment is exempt for...
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td className=" border-end">
                            Interest and dividend payments
                          </td>
                          <td>All exempt payees except for 7</td>
                        </tr>
                        <tr>
                          <td className=" border-end">Broker transactions</td>
                          <td>
                            Exempt payees 1 through 4 and 6 through 11 and all C
                            corporations. S corporations must not enter an
                            exempt payee code because they are exempt only for
                            sales of noncovered securities acquired prior to
                            2012.
                          </td>
                        </tr>
                        <tr>
                          <td className=" border-end">
                            Barter exchange transactions and patronage dividends
                          </td>
                          <td>Exempt payees 1 through 4</td>
                        </tr>
                        <tr>
                          <td className=" border-end">
                            Payments over $600 required to be reported and
                            direct sales over $5,000
                          </td>
                          <td>
                            Generally, exempt payees 1 through 5<sup>2</sup>
                          </td>
                        </tr>
                        <tr>
                          <td className=" border-end">
                            Payments made in settlement of payment card or third
                            party network transactions
                          </td>
                          <td>Exempt payees 1 through 4</td>
                        </tr>
                      </tbody>
                    </table>

                    <p>
                      <sup>1</sup> See Form 1099-MISC, Miscellaneous Income, and
                      its instructions.
                    </p>
                    <p>
                      <sup>2</sup> However, the following payments made to a
                      corporation and reportable on Form 1099-MISC are not
                      exempt from backup withholding: medical and health care
                      payments, attorneys’ fees, gross proceeds paid to an
                      attorney reportable under section 6045(f), and payments
                      for services paid by a federal executive agency.
                    </p>

                    <h4>Exemption from FATCA Reporting Code</h4>
                    <p>
                      The following codes identify payees that are exempt from
                      reporting under FATCA. These codes apply to persons
                      submitting this form for accounts maintained outside of
                      the United States by certain foreign financial
                      institutions. If you are only submitting this form for an
                      account you hold in the United States, you may leave this
                      field blank.
                    </p>
                    <ul className="list-group">
                      <li className="list-group-item">
                        A – An organization exempt from tax under section 501(a)
                        or any individual retirement plan as defined in section
                        7701(a)(37)
                      </li>
                      <li className="list-group-item">
                        B – The United States or any of its agencies or
                        instrumentalities
                      </li>
                      <li className="list-group-item">
                        C – A state, the District of Columbia, a U.S.
                        commonwealth or possession, or any of their political
                        subdivisions or instrumentalities
                      </li>
                      <li className="list-group-item">
                        D – A corporation the stock of which is regularly traded
                        on one or more established securities markets, as
                        described in Regulations section 1.1472-1(c)(1)(i)
                      </li>
                      <li className="list-group-item">
                        E – A corporation that is a member of the same expanded
                        affiliated group as a corporation described in
                        Regulations section 1.1472-1(c)(1)(i)
                      </li>
                      <li className="list-group-item">
                        F – A dealer in securities, commodities, or derivative
                        financial instruments (including notional principal
                        contracts, futures, forwards, and options) that is
                        registered as such under the laws of the United States
                        or any state
                      </li>
                      <li className="list-group-item">
                        G – A real estate investment trust
                      </li>
                      <li className="list-group-item">
                        H—A regulated investment company as defined in section
                        851 or an entity registered at all times during the tax
                        year under the Investment Company Act of 1940
                      </li>
                      <li className="list-group-item">
                        I—A common trust fund as defined in section 584(a)
                      </li>
                      <li className="list-group-item">
                        J—A bank as defined in section 581
                      </li>
                      <li className="list-group-item">K—A broker</li>
                      <li className="list-group-item">
                        L—A trust exempt from tax under section 664 or described
                        in section 4947(a)(1)
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            ),
          },
          {
            type: "content",
            className: "col-6",
            content: (
              <div className="container mt-3">
                <div className="row">
                  <div className="col">
                    <p>
                      M - A tax exempt trust under a section 403(b) plan or
                      section 457(g) plan.
                    </p>
                    <p>
                      <strong>Note:</strong> You may wish to consult with the
                      financial institution requesting this form to determine
                      whether the FATCA code and/or exempt payee code should be
                      completed.
                    </p>

                    <h4>Line 5</h4>
                    <p>
                      Enter your address (number, street, and apartment or suite
                      number). This is where the requester of this Form W-9 will
                      mail your information returns. If this address differs
                      from the one the requester already has on file, write NEW
                      at the top. If a new address is provided, there is still a
                      chance the old address will be used until the payor
                      changes your address in their records.
                    </p>

                    <h4>Line 6</h4>
                    <p>Enter your city, state, and ZIP code.</p>

                    <h4>Part I. Taxpayer Identification Number (TIN)</h4>
                    <p>
                      <b>Enter your TIN in the appropriate box.</b> If you are a
                      resident alien and you do not have and are not eligible to
                      get an SSN, your TIN is your IRS individual taxpayer
                      identification number (ITIN). Enter it in the social
                      security number box. If you do not have an ITIN, see{" "}
                      <strong>How to get a TIN</strong> below.
                    </p>
                    <p>
                      If you are a sole proprietor and you have an EIN, you may
                      enter either your SSN or EIN. If you are a single-member
                      LLC that is disregarded as an entity separate from its
                      owner, enter the owner’s SSN (or EIN, if the owner has
                      one). Do not enter the disregarded entity’s EIN. If the
                      LLC is classified as a corporation or partnership, enter
                      the entity’s EIN.
                    </p>
                    <p>
                      <strong>Note:</strong> See{" "}
                      <em>What Name and Number To Give the Requester</em>,
                      later, for further clarification of name and TIN
                      combinations.
                    </p>
                    <p>
                      <b>How to get a TIN.</b> If you do not have a TIN, apply
                      for one immediately. To apply for an SSN, get Form SS-5,
                      Application for a Social Security Card, from your local
                      SSA office or get this form online at www.SSA.gov. You may
                      also get this form by calling 1-800-772-1213. Use Form
                      W-7, Application for IRS Individual Taxpayer
                      Identification Number, to apply for an ITIN, or Form SS-4,
                      Application for Employer Identification Number, to apply
                      for an EIN. You can apply for an EIN online by accessing
                      the IRS website at www.irs.gov/Businesses and clicking on
                      Employer Identification Number (EIN) under Starting a
                      Business. Go to www.irs.gov/Forms to view, download, or
                      print Form W-7 and/or Form SS-4. Or, you can go to
                      www.irs.gov/OrderForms to place an order and have Form W-7
                      and/or SS-4 mailed to you within 10 business days.
                    </p>
                    <p>
                      If you are asked to complete Form W-9 but do not have a
                      TIN, apply for a TIN and write “Applied For” in the space
                      for the TIN, sign and date the form, and give it to the
                      requester. For interest and dividend payments, and certain
                      payments made with respect to readily tradable
                      instruments, generally you will have 60 days to get a TIN
                      and give it to the requester before you are subject to
                      backup withholding on payments. The 60-day rule does not
                      apply to other types of payments. You will be subject to
                      backup withholding on all such payments until you provide
                      your TIN to the requester.
                    </p>
                    <p>
                      <strong>Caution:</strong> A disregarded U.S. entity that
                      has a foreign owner must use the appropriate Form W-8.
                    </p>
                    <h4>Part II. Certification</h4>
                    <p>
                      To establish to the withholding agent that you are a U.S.
                      person, or resident alien, sign Form W-9. You may be
                      requested to sign by the withholding agent even if item 1,
                      4, or 5 below indicates otherwise.
                    </p>
                    <p>
                      For a joint account, only the person whose TIN is shown in
                      Part I should sign (when required). In the case of a
                      disregarded entity, the person identified on line 1 must
                      sign. Exempt payees, see Exempt payee code, earlier.
                    </p>
                    <p>
                      <b>Signature requirements.</b> Complete the certification
                      as indicated in items 1 through 5 below.
                    </p>
                  </div>
                </div>
              </div>
            ),
          },
          {
            type: "content",
            className: "col-6",
            content: (
              <div className="container mt-3">
                <div className="row">
                  <div className="col">
                    <ul>
                      <li>
                        <strong>
                          Interest, Dividend, and Barter Exchange Accounts
                          Opened Before 1984 and Active Broker Accounts During
                          1983:
                        </strong>{" "}
                        Correct TIN required, no need to sign the certification.
                      </li>
                      <li>
                        <strong>
                          Interest, dividend, broker, and barter exchange
                          accounts opened after 1983 and broker accounts
                          considered inactive during 1983:
                        </strong>{" "}
                        You must sign the certification or backup withholding
                        will apply. If you are subject to backup withholding and
                        you are merely providing your correct TIN to the
                        requester, you must cross out item 2 in the
                        certification before signing the form.
                      </li>
                      <li>
                        <strong>Real Estate Transactions:</strong> You must sign
                        the certification. You may cross out item 2 of the
                        certification.
                      </li>
                      <li>
                        <strong>Other Payments:</strong> You must give your
                        correct TIN, but you do not have to sign the
                        certification unless you have been notified that you
                        have previously given an incorrect TIN. “Other payments”
                        include payments made in the course of the requester’s
                        trade or business for rents, royalties, goods (other
                        than bills for merchandise), medical and health care
                        services (including payments to corporations), payments
                        to a nonemployee for services, payments made in
                        settlement of payment card and third party network
                        transactions, payments to certain fishing boat crew
                        members and fishermen, and gross proceeds paid to
                        attorneys (including payments to corporations).
                      </li>
                      <li>
                        <strong>
                          Mortgage interest paid by you, acquisition or
                          abandonment of secured property, cancellation of debt,
                          qualified tuition program payments (under section
                          529), ABLE accounts (under section 529A), IRA,
                          Coverdell ESA, Archer MSA or HSA contributions or
                          distributions, and pension distributions.
                        </strong>{" "}
                        You must give your correct TIN, but you do not have to
                        sign the certification.
                      </li>
                    </ul>

                    <h5>What Name and Number To Give the Requester</h5>
                    <table className="table">
                      <thead>
                        <tr>
                          <th className=" border-end">Type of Account</th>
                          <th>Give Name and SSN/EIN of:</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td className=" border-end">Individual</td>
                          <td>The individual</td>
                        </tr>
                        <tr>
                          <td className=" border-end">
                            Two or more individuals (joint account)
                          </td>
                          <td>
                            The actual owner or if combined funds, the first
                            individual on the account
                          </td>
                        </tr>
                        <tr>
                          <td className=" border-end">
                            Joint account maintained by an FFI
                          </td>
                          <td>Each holder of the account</td>
                        </tr>
                        <tr>
                          <td className=" border-end">
                            Custodial account of a minor (UGMA/UTMA)
                          </td>
                          <td>The minor</td>
                        </tr>
                        <tr>
                          <td className=" border-end">
                            Usual revocable savings trust (grantor is also
                            trustee)
                          </td>
                          <td>The grantor-trustee</td>
                        </tr>
                        <tr>
                          <td className=" border-end">
                            So-called trust account not a legal or valid trust
                            under state law
                          </td>
                          <td>The actual owner</td>
                        </tr>
                        <tr>
                          <td className=" border-end">
                            Sole proprietorship or disregarded entity owned by
                            an individual
                          </td>
                          <td>The owner</td>
                        </tr>
                        <tr>
                          <td className=" border-end">
                            Grantor trust filing under Optional Form 1099 Filing
                            Method 1
                          </td>
                          <td>The grantor</td>
                        </tr>
                        <tr>
                          <td className=" border-end">
                            Disregarded entity not owned by an individual
                          </td>
                          <td>The owner</td>
                        </tr>
                        <tr>
                          <td className=" border-end">
                            A valid trust, estate, or pension trust
                          </td>
                          <td>Legal entity</td>
                        </tr>
                        <tr>
                          <td className=" border-end">
                            Corporation or LLC electing corporate status
                          </td>
                          <td>The corporation</td>
                        </tr>
                        <tr>
                          <td className=" border-end">
                            Association, club, religious, charitable,
                            educational, or other tax-exempt organization
                          </td>
                          <td>The organization</td>
                        </tr>
                        <tr>
                          <td className=" border-end">
                            Partnership or multi-member LLC
                          </td>
                          <td>The partnership</td>
                        </tr>
                        <tr>
                          <td className=" border-end">
                            Broker or registered nominee
                          </td>
                          <td>The broker or nominee</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            ),
          },
          {
            type: "content",
            className: "col-6",
            content: (
              <div className="container mt-3">
                <div className="row">
                  <div className="col">
                    <table className="table">
                      <thead>
                        <tr>
                          <th className="border-end">Type of Account</th>
                          <th>Give Name and SSN/EIN of:</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td className="border-end">
                            14. Account with the Department of Agriculture in
                            the name of a public entity (such as a state or
                            local government, school district, or prison) that
                            receives agricultural program payments
                          </td>
                          <td>The public entity</td>
                        </tr>
                        <tr>
                          <td className="border-end">
                            15. Grantor trust filing under the Form 1041 Filing
                            Method or the Optional Form 1099 Filing Method 2
                            (see Regulations section 1.671-4(b)(2)(i)(B))
                          </td>
                          <td>The trust</td>
                        </tr>
                      </tbody>
                    </table>

                    <h4>Secure Your Tax Records From Identity Theft</h4>
                    <p>
                      Identity theft occurs when someone uses your personal
                      information such as your name, SSN, or other identifying
                      information, without your permission, to commit fraud or
                      other crimes. An identity thief may use your SSN to get a
                      job or may file a tax return using your SSN to receive a
                      refund.
                    </p>
                    <h5>To reduce your risk:</h5>
                    <ul>
                      <li>Protect your SSN,</li>
                      <li>Ensure your employer is protecting your SSN, and</li>
                      <li>Be careful when choosing a tax preparer.</li>
                    </ul>
                    <p>
                      If your tax records are affected by identity theft and you
                      receive a notice from the IRS, respond right away to the
                      name and phone number printed on the IRS notice or letter.
                    </p>
                    <p>
                      If your tax records are not currently affected by identity
                      theft but you think you are at risk due to a lost or
                      stolen purse or wallet, questionable credit card activity
                      or credit report, contact the IRS Identity Theft Hotline
                      at 1-800-908-4490 or submit Form 14039.
                    </p>
                    <p>
                      For more information, see Pub. 5027, Identity Theft
                      Information for Taxpayers.
                    </p>
                    <p>
                      Victims of identity theft who are experiencing economic
                      harm or a systemic problem, or are seeking help in
                      resolving tax problems that have not been resolved through
                      normal channels, may be eligible for Taxpayer Advocate
                      Service (TAS) assistance. You can reach TAS by calling the
                      TAS toll-free case intake line at 1-877-777-4778 or
                      TTY/TDD 1-800-829-4059.
                    </p>
                    <p>
                      <b>
                        Protect yourself from suspicious emails or phishing
                        schemes.
                      </b>{" "}
                      Phishing is the creation and use of email and websites
                      designed to mimic legitimate business emails and websites.
                      The most common act is sending an email to a user falsely
                      claiming to be an established legitimate enterprise in an
                      attempt to scam the user into surrendering private
                      information that will be used for identity theft.
                    </p>
                  </div>
                </div>
              </div>
            ),
          },
          {
            type: "content",
            className: "col-12",
            content: (
              <div className="container mt-3">
                <div className="row">
                  <div className="col-md-6">
                    <p>
                      The IRS does not initiate contacts with taxpayers via
                      emails. Also, the IRS does not request personal detailed
                      information through email or ask taxpayers for the PIN
                      numbers, passwords, or similar secret access information
                      for their credit card, bank, or other financial accounts.
                    </p>
                    <p>
                      If you receive an unsolicited email claiming to be from
                      the IRS, forward this message to{" "}
                      <a href="mailto:phishing@irs.gov">phishing@irs.gov</a>.
                      You may also report misuse of the IRS name, logo, or other
                      IRS property to the Treasury Inspector General for Tax
                      Administration (TIGTA) at 1-800-366-4484. You can forward
                      suspicious emails to the Federal Trade Commission at
                      <a href="mailto:spam@uce.gov">spam@uce.gov</a> or report
                      them at{" "}
                      <a href="https://www.ftc.gov/complaint">
                        www.ftc.gov/complaint
                      </a>
                      . You can contact the FTC at{" "}
                      <a href="https://consumer.ftc.gov/features/identity-theft">
                        www.ftc.gov/idtheft
                      </a>{" "}
                      or 877-IDTHEFT (877-438-4338). If you have been the victim
                      of identity theft, see{" "}
                      <a href="https://www.identitytheft.gov/">
                        www.IdentityTheft.gov
                      </a>{" "}
                      and Pub. 5027. Visit www.irs.gov/Id
                    </p>
                    <p>
                      Visit{" "}
                      <a href="https://www.irs.gov/identity-theft-central">
                        www.irs.gov/IdentityTheft
                      </a>{" "}
                      to learn more about identity theft and how to reduce your
                      risk.
                    </p>
                  </div>
                  <div className="col-md-6">
                    <h4>Privacy Act Notice</h4>
                    <p>
                      Section 6109 of the Internal Revenue Code requires you to
                      provide your correct TIN to persons (including federal
                      agencies) who are required to file information returns
                      with the IRS to report interest, dividends, or certain
                      other income paid to you; mortgage interest you paid; the
                      acquisition or abandonment of secured property; the
                      cancellation of debt; or contributions you made to an IRA,
                      Archer MSA, or HSA. The person collecting this form uses
                      the information on the form to file information returns
                      with the IRS, reporting the above information. Routine
                      uses of this information include giving it to the
                      Department of Justice for civil and criminal litigation
                      and to cities, states, the District of Columbia, and U.S.
                      commonwealths and possessions for use in administering
                      their laws. The information also may be disclosed to other
                      countries under a treaty, to federal and state agencies to
                      enforce civil and criminal laws, or to federal law
                      enforcement and intelligence agencies to combat terrorism.
                      You must provide your TIN whether or not you are required
                      to file a tax return. Under section 3406, payers must
                      generally withhold a percentage of taxable interest,
                      dividend, and certain other payments to a payee who does
                      not give a TIN to the payer. Certain penalties may also
                      apply for providing false or fraudulent information.
                    </p>
                  </div>
                </div>
              </div>
            ),
          },
        ],
      },
    ],
  },
];

export const signatureAuthArr = [
  {
    field: "Borrower Signature Authorization",
    arr: [
      {
        section: "",
        arr: [
          {
            content: (
              <>
                <b>Privacy Act Notice:</b>This information is to be used by the
                agency collecting it or its assignees in determining whether you
                qualify as a prospective mortgagor under its program. It will
                not be disclosed outside the agency except as required and
                permitted by law. You do not have to provide this information,
                but if you do not your application for approval as a prospective
                mortgagor or borrower may be delayed or rejected. The
                information requested in this form is authorized by Title 38,
                USC, Chapter 37 (if VA); by 12 USC, Section 1701 et. seq. (if
                HUD/FHA); by 42 USC, Section 1452b (if HUD/CPD); and Title 42
                USC, 1471 et. seq., or 7 USC, 1921 et. seq. (if USDA/FmHA).
              </>
            ),
            type: "content",
            className: "col-12",
          },
        ],
      },
      {
        section: "Part I - General Information",
        arr: [
          {
            title: "Borrower",
            field: "borrower",
            type: "text",
            className: "col-6",
          },
          {
            title: "Name and address of Lender/Broker",
            field: "lenderBrokerNameAddress",
            type: "text",
            className: "col-6",
          },
          {
            title: "Date",
            field: "date",
            type: "date",
            className: "col-3",
          },
          {
            title: "Loan Number",
            field: "loanNumber",
            type: "text",
            className: "col-3",
          },
        ],
      },
      {
        section: "Part II - Borrower Authorization",
        arr: [
          {
            content: (
              <>
                <p>
                  I hereby authorize the Lender/Broker to verify my past and
                  present employment earnings records, bank accounts, stock
                  holdings, and any other asset balances that are needed to
                  process my mortgage loan application. I further authorize the
                  Lender/Broker to order a consumer credit report and verify
                  other credit information, including past and present mortgage
                  and landlord references. It is understood that a copy of this
                  form will also serve as authorization.
                </p>
                <p>
                  The information the Lender/Broker obtains is only to be used
                  in the processing of my application for a mortgage loan.
                </p>
              </>
            ),
            type: "content",
          },
          {
            title: "Borrower",
            field: "borrowerSignature",
            type: "text",
            className: "col-6",
          },
          {
            title: "Date",
            field: "signatureDate",
            type: "date",
            className: "col-6",
          },
        ],
      },
    ],
  },
];

export const drawRequestFormArr = [
  {
    field: "DRAW REQUEST FORM",
    arr: [
      {
        section: "",
        arr: [
          {
            title: "Draw Number",
            field: "drawNumber",
            type: "text",
            className: "col-12",
          },
          {
            title: "Loan ID Number",
            field: "loanIdNumber",
            type: "text",
            className: "col-12",
          },
          {
            title: "Property Address",
            field: "propertyAddress",
            type: "textarea",
            className: "col-12",
          },
          {
            title: "Draw Amount",
            field: "drawAmount",
            type: "text",
            className: "col-12",
          },
        ],
      },
      {
        section: "",
        className: "col-12",
        arr: [
          {
            title: "Select Payment Method",
            field: "paymentMethod",
            type: "radio",
            options: [
              {
                title: "ACH Direct Deposit ($30)",
                value: "ACH",
              },
              {
                title: "Wire Payment ($45)",
                value: "wire",
              },
              {
                title: "Check ($30)",
                value: "check",
              },
            ],
            className: "col-12",
          },
          {
            type: "content",
            className: "col-12",
            content: (
              <div>
                <p>
                  Borrower has requested this draw (“Draw Request”) for the
                  purpose of paying the contractors, subcontractors and/or
                  suppliers who have furnished services, materials, or labor to
                  the date of this Draw Request.
                </p>
                <b>
                  NOTE: Superior Loan Servicing requires a completed W-9Form for
                  all payees prior to distribution of any funds.
                </b>
              </div>
            ),
          },
        ],
      },
      {
        section: "Payee Information",
        className: "col-12",
        arr: [
          {
            title: "Payee Name",
            field: "payeeName",
            type: "text",
            className: "col-12",
          },
          {
            title: "Complete Address",
            field: "completeAddress",
            type: "textarea",
            className: "col-12",
          },
          {
            title: "Bank Name",
            field: "bankName",
            type: "text",
            className: "col-12",
          },
          {
            title: "ACH Routing Number",
            field: "achRoutingNumber",
            type: "text",
            className: "col-12",
          },
          {
            title: "Wire Routing Number",
            field: "wireRoutingNumber",
            type: "text",
            className: "col-12",
          },
          {
            title: "Bank Account Number",
            field: "bankAccountNumber",
            type: "text",
            className: "col-12",
          },
        ],
      },
      {
        section: "",
        className: "col-12",
        arr: [
          {
            title: "Approved by Signature",
            field: "approvedBy",
            type: "text",
            className: "col-12",
          },
          {
            title: "Borrower Signature (If applicable)",
            field: "borrowerSignature",
            type: "text",
            className: "col-12",
          },
          {
            type: "content",
            className: "col-12",
            content: (
              <div>
                <p>
                  Please complete this form and submit request to{" "}
                  <a href="mailto:lss@slsbox.com">lss@slsbox.com</a>
                </p>
                <p>
                  *ACH cut off time is 4:00 PM PST for next day delivery. Wire
                  cut off time is 2:00 PM PST for same day delivery.{" "}
                  <u>
                    PLEASE NOTE THAT SLS WILL PAY THE ENTIRE DRAW AMOUNT TO THE
                    PAYEE. SLS DRAW FEES WILL BE DEDUCTED SEPARATELY FROM
                    REMAINING FUNDS.
                  </u>
                </p>
              </div>
            ),
          },
        ],
      },
    ],
  },
];

export const borrower3rdArr = [
  {
    field: "BORROWER 3RD PARTY AUTHORIZATION FORM",
    arr: [
      {
        section: "",
        arr: [
          {
            type: "content",
            className: "col-12",
            content: (
              <p>
                This Borrower Authorization Form will allow Superior Loan
                Servicing or its authorized representatives to share information
                about your mortgage with third parties
              </p>
            ),
          },
        ],
      },
      {
        section: "Borrower Information",
        arr: [
          {
            title: "Date",
            field: "date",
            type: "date",
            className: "col-12",
          },
          {
            title: "Loan ID Number",
            field: "loanIdNumber",
            type: "text",
            className: "col-12",
          },
          {
            title: "Property Address",
            field: "propertyAddress",
            type: "textarea",
            className: "col-12",
          },
          {
            type: "content",
            className: "col-12",
            content: (
              <p>
                The undersigned Borrower and Co-Borrower (if any), authorize
                Superior Loan Servicing and its authorized representatives to
                release, furnish, provide, exchange, and request information
                related to my/our loan to:{" "}
              </p>
            ),
          },
        ],
      },
      {
        section: "Authorized Third Party Contact Information",
        className: "col-12",
        arr: [
          {
            title: "Name",
            field: "thirdPartyName",
            type: "text",
            className: "col-6",
          },
          {
            title: "Name",
            field: "thirdPartyName2",
            type: "text",
            className: "col-6",
          },
          {
            title: "Address",
            field: "thirdPartyAddress",
            type: "textarea",
            className: "col-6",
          },
          {
            title: "Address",
            field: "thirdPartyAddress2",
            type: "textarea",
            className: "col-6",
          },
          {
            title: "Phone Number",
            field: "thirdPartyPhoneNumber",
            type: "phoneNumber",
            className: "col-6",
          },
          {
            title: "Phone Number",
            field: "thirdPartyPhoneNumber2",
            type: "phoneNumber",
            className: "col-6",
          },
          {
            title: "Email Address",
            field: "thirdPartyEmailAddress",
            type: "email",
            className: "col-6",
          },
          {
            title: "Email Address",
            field: "thirdPartyEmailAddress2",
            type: "email",
            className: "col-6",
          },
          {
            title:
              "I authorize the 3rd party listed above to make payments on my behalf.",
            field: "authorizePayments",
            type: "checkbox",
            className: "col-6",
          },
          {
            title:
              "I authorize the 3rd party listed above to make decisions on loan extensions/modifications.",
            field: "authorizePayments2",
            type: "checkbox",
            className: "col-6",
          },
          {
            type: "content",
            className: "col-12",
            content: (
              <div>
                <p className="fw-bold">Expiration of Authorization</p>
                <p>
                  If applicable, please specify a period of time or the
                  particulare transaction for which the authorization is valid.
                  If no expiration date or operational transaction is provided,
                  this authorization will remain valid until revoked in writing.
                </p>
              </div>
            ),
          },
          {
            type: "content",
            className: "col-6",
            content: <label>Enter Date of Expiration (if applicable):</label>,
          },
          {
            title: "Date of Expiration",
            field: "authorizationExpiration",
            type: "date",
            className: "col-6",
          },
          {
            type: "content",
            className: "col-12",
            content: (
              <div>
                <u>
                  You may revoke this authorization at any time by providing
                  written notice to Superior Loan Servicing.
                </u>
                <p>
                  I/We hereby indemnify and forever hold Superior Loan Servicing
                  harmless from any and all actions and causes of actions,
                  suits, claims, attorney’s fees, or demands against Superior
                  Loan Servicing, which I/we and/or my/our heirs may have
                  resulting from Superior Loan Servicing discussing, or
                  declining to discuss, my/our account with the above-named
                  requestor or person identifying himself/herself to be that
                  requestor, or resulting from providing, or declining to
                  provide, any documents or other information concerning the
                  account to the requestor.
                </p>
              </div>
            ),
          },
          {
            title: "Borrower Signature",
            field: "borrowerSignature",
            type: "text",
            className: "col-6",
          },
          {
            title: "Borrower 2 Signature",
            field: "borrower2Signature",
            type: "text",
            className: "col-6",
          },
          {
            title: "Print Name",
            field: "borrowerPrintName",
            type: "text",
            className: "col-6",
          },
          {
            title: "Print Name 2",
            field: "borrower2PrintName",
            type: "text",
            className: "col-6",
          },
          {
            type: "content",
            className: "col-12",
            content: (
              <p>
                Please complete this form and return it by mail or email to
                <a href="mailto:lss@slsbox.com"> lss@slsbox.com</a>
              </p>
            ),
          },
        ],
      },
    ],
  },
];

export const financialAssistArr = [
  {
    field: "BORROWER 3RD PARTY AUTHORIZATION FORM",
    arr: [
      {
        section: "",
        arr: [
          {
            type: "content",
            className: "col-12",
            content: (
              <p>
                If you or your business are unable to make mortgage payments due
                to a recent financial hardship and you are in need of financial
                assistance, or your loan has matured and you are in need of an
                extension you must complete this form and submit it to{" "}
                <a href="mailto:assistance@superiorloanservicing.com">
                  assistance@superiorloanservicing.com
                </a>
                , mail or fax (see company information below). It is important
                that you understand that your request will be submitted to your
                Lender for review and final approval, therefore it is very
                important that you fully complete this form and provide the
                details of your financial hardship or reason for your extension
                request.
              </p>
            ),
          },
        ],
      },
      {
        section: "",
        arr: [
          {
            title: "I want to:",
            field: "requestType",
            type: "radio",
            options: [
              {
                title: "Apply for Financial Assistance",
                value: "financialAssistance",
              },
              {
                title: "Apply for a Loan Maturity Extension",
                value: "loanMaturityExtension",
              },
            ],
            className: "col-12",
          },
        ],
      },
      {
        section: "Borrower(s) Information",
        arr: [
          {
            title: "Loan Number",
            field: "loanNumber",
            type: "text",
            className: "col-12",
          },
          {
            title: "Borrower(s) Name(s)",
            field: "borrowerNames",
            type: "textarea",
            className: "col-12",
          },
          {
            title: "Contact Phone Number(s)",
            field: "contactPhoneNumbers",
            type: "phoneNumber",
            className: "col-6",
          },
          {
            title: "Contact Email(s)",
            field: "contactEmails",
            type: "email",
            className: "col-6",
          },
          {
            title: "Mailing Address",
            field: "mailingAddress",
            type: "text",
            className: "col-12",
          },
          {
            title: "Mortgage Property Address",
            field: "mortgagePropertyAddress",
            type: "textarea",
            className: "col-12",
          },
        ],
      },
      {
        section: (
          <>
            <h4>Financial Assitance Hardship Information</h4>
            <p>
              (if you chose Financial Assitance above then complete this
              section)
            </p>
          </>
        ),
        className: "col-12",
        arr: [
          {
            type: "content",
            className: "col-12",
            content: (
              <label>
                Please explain your financial situation and why you are having
                difficulty making your loan payments. It is important that you
                be as specific as possible to help your lender determine the
                best course of action for your specific circumstances (e.g.
                Reduction in work hours, reducing my paycheck; My partner/spouse
                loss his/her job reducing my monthly salary to $XXXXX)
              </label>
            ),
          },
          {
            title: "Financial Assistance Hardship Information",
            field: "financialHardshipInformation",
            type: "textarea",
            className: "col-12",
          },
        ],
      },
      {
        section: (
          <>
            <p>Loan Maturity Extension Information </p>
            <p>
              (if you Loan Maturity Extensioni above then complete this section)
            </p>
          </>
        ),
        className: "col-12",
        arr: [
          {
            type: "content",
            className: "col-12",
            content: (
              <p>
                Please detail the reason for your extension request. (e.g. If
                you are refinancing, provide the scheduled date the loan will
                close; if you are not refinancing, detail how long you wish to
                extend your loan and why)
              </p>
            ),
          },
          {
            title: "Loan Maturity Extension Information",
            field: "loanMaturityExtensionInformation",
            type: "textarea",
            className: "col-12",
          },
        ],
      },
      {
        section: "Acknowledgement",
        className: "col-12",
        arr: [
          {
            type: "content",
            className: "col-12",
            content: (
              <p>
                I certify that I understand this request and that all the
                information I provided is true and accurate.
              </p>
            ),
          },
          {
            title: "Borrower Signature",
            field: "borrowerSignature",
            type: "text",
            className: "col-6",
          },
          {
            title: "Date",
            field: "signatureDate",
            type: "date",
            className: "col-6",
          },
          {
            title: "Borrower 2 Signature",
            field: "borrower2Signature",
            type: "text",
            className: "col-6",
          },
          {
            title: "Date",
            field: "signatureDate2",
            type: "date",
            className: "col-6",
          },
          {
            type: "content",
            className: "col-12",
            content: (
              <b>
                Please complete this form and email to{" "}
                <a href="mailto:assistance@superiorloanservicing.com">
                  assistance@superiorloanservicing.com
                </a>
              </b>
            ),
          },
        ],
      },
    ],
  },
];
